import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up",
  "use": "icon-chevron-up-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-chevron-up\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M3.999 12.193L5.066 13.5 10 9.114l4.934 4.386 1.067-1.307L10 6.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol